import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import moment from 'moment';
import { ReportService } from 'src/app/services/report.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-move-address-report',
  templateUrl: './move-address-report.component.html',
  styleUrls: ['./move-address-report.component.scss']
})
export class MoveAddressReportComponent implements OnInit {


   movingAddressReportForm: FormGroup;
    toMinDate: Date;
    toMaxDate=new Date()
    @ViewChild('startDate') startDateDatePicker: MatDatepicker<Date>;
    @ViewChild('endDate') endDateDatePicker: MatDatepicker<Date>;
    orderStatusList: any = []
    filteredList1: any = []
    serviceQueue: any = []

    constructor(
        private fb: FormBuilder,
        private reportService: ReportService,
    ) {
    }


    ngOnInit(): void {
        this.init()
    }
    init() {
        this.movingAddressReportForm = this.fb.group({
            startDate: [null, Validators.required],
            endDate: [null, Validators.required],
        });
    }
    Reset() {
        this.movingAddressReportForm.reset()
    }
    openStartDateDatePicker() {
        this.startDateDatePicker.open();
    }

    openEndDateDatePicker() {
        this.endDateDatePicker.open();
        this.toMinDate = this.movingAddressReportForm.controls["startDate"].value;
    }


    generateExcel() {
        debugger
        if (!this.movingAddressReportForm.value.startDate && !this.movingAddressReportForm.value.endDate) {
            Swal.fire({
                icon: 'warning',
                title: 'From date and To date should not be empty',
                position: 'center',

            })
        }
        else if (!this.movingAddressReportForm.value.startDate) {
            Swal.fire({
                icon: 'warning',
                title: 'From date should not be empty',
                position: 'center',

            })
        }
        else if (!this.movingAddressReportForm.value.endDate) {
            Swal.fire({
                icon: 'warning',
                title: 'End date should not be empty',
                position: 'center',

            })
        }
        else if (this.movingAddressReportForm.value.startDate > this.movingAddressReportForm.value.endDate) {
            if (this.movingAddressReportForm.value.endDate) {
                Swal.fire({
                    icon: 'warning',
                    title: 'End Date should be greater than Start Date',
                    position: 'center',
                })
            }
        }
        else {

            var edate = new Date(this.movingAddressReportForm.value.endDate);
            var sdate = new Date(this.movingAddressReportForm.value.startDate);

            var months;
            months = (edate.getFullYear() - sdate.getFullYear()) * 12;
            months -= sdate.getMonth();
            months += edate.getMonth();
            months = months <= 0 ? 0 : months;

            if (months > 2) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Incorrect needs to show validation',
                    position: 'center',
                })
            }
            else {
                this.reportService.getMovingAddressReport(this.movingAddressReportForm.value).subscribe( (result)=> {
                    if (result) {
                        const linkSource = 'data:application/vnd.openxmlformats - officedocument.spreadsheetml.sheet;base64, ' + result;
                        const downloadLink = document.createElement('a');
                        const fileName = 'Move Address Report.xls';
                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        downloadLink.click();
                    }
                });
            }



        }
        }


    }



